/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.26/esri/copyright.txt for details.
*/
const c="20230227",f="2ffb373909cc330536324a33c00959f98d434afa";export{c as buildDate,f as commitHash};
